<template src="./Details.html">
</template>

<script>
export default {
        props: {
            itemId: {
                type: Number,
                required: true,
            },
        },

        created() {
            this.$store
                .dispatch("instructions/getDetails", this.itemId)
                .then(() => {

                })
                .catch(() => { });
        },
        data() {
    return {

   

    };
  },
  computed: {
    instructions() {
          return this.$store.state.instructions.instructions;
      }
  },
};
</script>